import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import PageHeading from '../PageHeading';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import Button from '../Button';
import Accordion from '../Accordion';
import IconBox from '../IconBox'
import Cta from '../Cta';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function ServicesPage() {
  pageTitle('Service');

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo(0, 0);
  }, []);

  const serviceSections = [
    {
      title: 'Engineering Design',
      description:
        'We offer expert 3D CAD modeling, prototyping, and design optimization services to bring your concepts to life with precision and functionality. Our design process focuses on performance, manufacturability, and innovation.',
      image: '/images/service/EngineeringDesign.png',
    },
    {
      title: 'Simulations & Analysis',
      description:
        'Our team conducts advanced simulations, including CFD (Computational Fluid Dynamics), FEA (Finite Element Analysis), and thermal, structural, and vibration analysis to validate and optimize designs under real-world conditions.',
      image: '/images/service/simulations.png',
    },
    {
      title: 'Rendering & Animations',
      description:
        'We produce high-quality industrial renderings and animations that visually communicate complex products and systems. Ideal for presentations, marketing, and investor engagement, our visuals combine realism with technical accuracy.',
      image: '/images/service/Rendering&Animations.png',
    },
    {
      title: 'Custom Engineering Solutions',
      description:
        'We develop tailored engineering solutions to address specific industrial challenges. Whether it’s improving efficiency, solving technical bottlenecks, or creating entirely new systems, our team delivers.',
      image: '/images/service/cusE.png',
    },
  ];

  return (
    <>
      <PageHeading
        title="Services"
        bgSrc="images/service_hero_bg.jpeg"
        pageLinkText="Services"
      />
      <Spacing lg="145" md="80" />


      <Div className="container">
        <SectionHeading 
          title='What sets us apart' 
          subtitle='' 
          variant='cs-style1 text-center'
        />
        <Spacing lg='90' md='45'/>
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_7.svg'
              title='Engineering excellence'
              subtitle='Our work is grounded in technical mastery. From advanced simulations to precision manufacturing, we apply rigorous engineering principles to achieve unmatched quality and performance.'
            />
            <Spacing lg='30' md='30'/>
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_6.svg'
              title='Dependable partnership'
              subtitle='We view every client relationship as a long-term collaboration. With transparent communication, consistent timelines, and a commitment to your success, we’re a partner you can trust. Project after project.'
            />
            <Spacing lg='30' md='30'/>
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_5.svg'
              title='Agile Innovation'
              subtitle='We bring agile, cross-disciplinary thinking to every challenge, integrating the latest tools and techniques to craft solutions that meet real-world demands. Today and tomorrow.'
            />
            <Spacing lg='30' md='30'/>
          </Div>
        </Div>
      </Div>
      <Spacing lg='145' md='80'/>

      {serviceSections.map((service, idx) => (
        <Div className="container" key={idx}>
          <Div
            className="row align-items-center cs-service-block"
            data-aos={idx % 2 === 0 ? 'fade-up' : 'fade-left'}
          >
            <Div className={`col-xl-5 col-lg-6 ${idx % 2 !== 0 ? 'order-lg-2' : ''}`}>
              <Div className="cs-radius_15 cs-shine_hover_1">
                <img
                  src={service.image}
                  alt={service.title}
                  className="cs-radius_15 w-100"
                  style={{ height: '450px', objectFit: 'cover' }}
                />
              </Div>
              <Spacing lg="0" md="40" />
            </Div>
            <Div className={`col-lg-6 offset-xl-1 ${idx % 2 !== 0 ? 'order-lg-1' : ''}`}>
              <h2 className="cs-font_40 cs-m0">{service.title}</h2>
              <Spacing lg="30" md="20" />
              <p>{service.description}</p>
              <Spacing lg="20" md="20" />
              {/* <Button
                btnLink="/service/service-details"
                btnText="Explore More"
                variant="cs-type2"
              /> */}
            </Div>
          </Div>
          <Spacing lg="120" md="60" />
        </Div>
      ))}
      <Spacing lg="120" md="60" />
      <Div className="container cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-5 col-lg-6">
              <SectionHeading
                title="Some pre questions and answers"
                subtitle="FAQ’s"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-lg-6 offset-xl-1">
              <Accordion />
            </Div>
          </Div>
        </Div>
      </Div>

      <Spacing lg="150" md="80" />

      <Div className="container">
        <Cta
          title="Connect. Collaborate. Create."
          btnText="Get in Touch"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
    </>
  );
}
